import React from 'react';
import { UuidString } from '../../../types';
import { useGetUserByIdQuery } from '../../../app/services/userApi';

type Props = { 
    userId: UuidString
}

/** Displays User's Icon and Name 
 * @params {UuidString} [userHash] - User's ID */
const UserBanner: React.FC<Props> = ({userId}) => {
    const {data: user, isFetching } = useGetUserByIdQuery({userId})

    return (
        <div className='d-flex'>
            {isFetching ? (
                <div className="placeholder-glow d-flex w-100"> 
                    <div className="flex-shrink-0 placeholder rounded-circle border-1 border user-image me-3" style={{ width: 40, height: 40 }}></div>
                    <p className="placeholder my-2">Placeholder name</p>
                </div>
            ) : ( user && (
                <div className="align-items-center d-flex w-100"> 
                    <img
                        className="rounded-circle border-1 border bg-primary user-image me-3"
                        style={{ width: 40, height: 40 }}
                        src={user?.meta?.avatar ?? "https://gravatar.com/avatar?d=mp&s=30"}
                        alt={`${user?.meta?.name}`}
                    />
                    <small>{user?.meta?.name ?? "Unknown"}</small>
                </div>
            ))}
        </div>
    )
}

export default UserBanner;